function modal() {
    var modal = document.querySelector('.modal'),
        modalClose = document.querySelectorAll('.modal__close'),
        body = document.querySelector('body');

    // Check if the cookie is set to determine whether to show the modal
    var modalCookie = getCookie('modalClosed');
    if (!modalCookie) {
        modal.classList.remove('hidden');
        body.classList.add('overflow--hidden');
    }

    modalClose.forEach(function (el) {
        el.addEventListener('click', function (e) {
            closeModal(e);
        });
    });

    modal.addEventListener('click', function (event) {
        if (!document.querySelector('.modal__box').contains(event.target)) {
            closeModal(event);
        }
    });
}

function closeModal(event) {
    var parent = event.target.closest('.modal');
    body.classList.remove('overflow--hidden');
    parent.classList.add('hidden');

    // Set a cookie to remember that the modal was closed and expires in a week
    var expirationDate = new Date();
    expirationDate.setDate(expirationDate.getDate() + 7); // Add 7 days to the current date

    document.cookie = 'modalClosed=true; expires=' + expirationDate.toUTCString() + '; path=/'
}

// Function to retrieve the value of a cookie
function getCookie(name) {
    var cookies = document.cookie.split(';');
    for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i].trim();
        if (cookie.startsWith(name + '=')) {
            return cookie.substring(name.length + 1);
        }
    }
    return null;
}

modal();


// function modal() {
//     var modal = document.querySelector('.modal'), 
//         modalClose = document.querySelectorAll('.modal__close'),
//         body = document.querySelector('body')

//     modalClose.forEach(function (el) {
//         el.addEventListener('click', function(e) {
//             closeModal(e)
//         })
//     })

//     modal.addEventListener('click', function(event) {
//         if(!document.querySelector('.modal__box').contains(event.target)) {
//             closeModal(event)
//         }
//     })
// }

// function closeModal(event) {
//     var parent = event.target.closest('.modal')
//     body.classList.remove('overflow--hidden')
//     parent.classList.add('hidden')
// }

// modal()